export default __webpack_public_path__ + "static/media/hot-product-white.05e517c3.png";